import { InputHTMLAttributes, useEffect, useRef } from 'react';
import { IMaskInput } from 'react-imask';

const RUSSIAN_PHONE_PATTERN = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
const RUSSIAN_PHONE_PATTERN_ATTRIBUTE = '\\+7 \\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}';
const RUSSIAN_PHONE_VALIDATION_MESSAGE = 'Укажите телефон в формате +7 (949) 123-45-67.';

type PhoneInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
  onValueChange: (value: string) => void;
  value: string;
};

export function PhoneInput({ onValueChange, value, ...inputProps }: PhoneInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const phoneInput = inputRef.current;

    if (phoneInput === null) {
      return;
    }

    const isValidPhone = value === '' || RUSSIAN_PHONE_PATTERN.test(value);
    const validationMessage = isValidPhone ? '' : RUSSIAN_PHONE_VALIDATION_MESSAGE;

    phoneInput.setAttribute('pattern', RUSSIAN_PHONE_PATTERN_ATTRIBUTE);
    phoneInput.setCustomValidity(validationMessage);
  }, [value]);

  return (
    <IMaskInput
      {...inputProps}
      inputRef={inputRef}
      mask="+{7} (000) 000-00-00"
      onAccept={(nextValue) => {
        const phoneValue = String(nextValue);

        onValueChange(phoneValue);
      }}
      overwrite
      placeholder="+7 (949) 123-45-67"
      type="tel"
      value={value}
    />
  );
}
